<!--
 * @Description: 列表审核记录tooltip组件
 * @Author: gaohc
 * @Date: 2022-10-20 16:43:52
-->
<template>
  <div class="history-tooltip-wrap">
    <el-tooltip popper-class="review-tooltip" effect="light" placement="right">
      <div slot="content">
        <div class="time-line-wrap">
          <el-timeline>
            <el-timeline-item v-for="(item, index) in data" :key="index"
              :color="item.reviewStatus == '2' || item.reviewStatus == '35' ? '#FF0909' : '#1BAA60'">
              <div class="review-history-text" :style="{color: item.reviewStatus == '2' 
                || item.reviewStatus == '35' ? '#FF0909' : '#1baa60'}">
                <div>
                  <span>{{ item.reviewStatusText }}</span>
                </div>
                <div style="margin-top: 3px">{{ item.time }}</div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <span class="review-status-text" :style="{color: reviewStatus == '2' || reviewStatus == '35'
				? '#FF0909' : reviewStatus == '0' ? '#999999' : '#606266'}">
        {{ statusText }}
      </span>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "ReviewTooltip",
  props: ["statusText", "data", "reviewStatus"],
};
</script>

<style scoped>
.history-tooltip-wrap{
  text-align: left;
}
.time-line-wrap {
  min-width: 180px;
  background: #feffff;
  display: flex;
  align-items: center;
  padding: 20px 20px 0 0;
}

.review-history-text {
  font-size: 14px;
  line-height: 20px;
}

.el-tooltip__popper .time-line-wrap /deep/ .el-timeline {
  padding-left: 20px;
}

.el-tooltip__popper .time-line-wrap /deep/ .el-timeline-item__tail {
  left: 4px;
  border-left: 2px solid #1baa60;
}

.review-status-text {
  text-align: left;
  cursor: pointer;
}
</style>

<style>
.review-tooltip{
  border: 1px solid #eaedf4 !important;
  padding-bottom: 0;
  max-height: 500px;
  overflow-y: auto;
}

.review-tooltip[x-placement^=right] .popper__arrow{
   border-right-color: #eaedf4 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/review/components/ReviewTooltip.vue